import { usePage } from "PFApp/use_page";
import React, { useEffect } from "react";
import { Redirect, useLocation, useParams } from "react-router-dom";

export const useTabs = (pageName, tabs) => {
  const location = useLocation();
  const { section } = useParams();
  const storageKey = `previous_${pageName}_section`;
  const parsedSection = section || window.storage.getItem(storageKey) || tabs[0].id;

  useEffect(() => {
    // We want to be able to go back to our previous tab when we navigate away and come back
    window.storage.setItem(storageKey, parsedSection);
  }, [parsedSection]);

  const {
    page: { tab },
    mergePage
  } = usePage(pageName, {});

  useEffect(() => {
    mergePage({ tab: parsedSection });
  }, [parsedSection]);

  if (section && !tabs.map((tab) => tab.id).includes(section)) {
    return <Redirect to={location.pathname} />;
  }

  return {
    tab,
    changeTab: (value) => mergePage({ tab: value })
  };
};
